// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"939":"fcced9c5","1489":"54e82484","1495":"1282e03c","4650":"54e82484","4688":"54e82484","6962":"55b4087e","9341":"83e626b7","9686":"31d6cfe0"}[chunkId] + ".chunk.css";
};